import api from 'api'
import type { CallStartResponse, CallTransport } from './types'

type StartSkillsCollectionCallRequest = {
  transport?: CallTransport
}

export const startSkillsCollectionCall = async (
  request: StartSkillsCollectionCallRequest
): Promise<CallStartResponse> => {
  const result = await api.post(
    '/admin/coach/skills_collection/start_call',
    request
  )
  return result.data as CallStartResponse
}
